import store from '../store';
import RegulatoryQuestions from './RegulatoryQuestions.vue';
import OptOutQuestion from './OptOutQuestion.vue';

const insurance = {
  retired: false,
  overseas: false,
  member: false,
  gbFoundationTrainee: false,
  overseasFoundationTrainee: false,
  initialComponent: undefined,
  pliForRetiredOrOverseas: undefined,
  ftQualifiedIn2025: false,
  overseasFtOrGbFtWhoQualifiedIn2025: false,
  nextButton: 'Next',
  retiredStatement: `Your retired membership does not include our Professional Liability Insurance.
    Please change your employment status if you are still working and require our Insurance.`,
  overseasStatement: `As an overseas member of our community, unfortunately we are unable to
    offer you our Professional Liability Insurance at the moment.`,
  ftQualifiedIn2025Statement: `As a Foundation Trainee taking your registration assesment in 2025 you are not yet eligible for our Insurance product.
   However you will be able to purchase your insurance when you upgrade to a qualified Member.`,
  optOut: {
    process: 'optOut',
    statement: 'Your membership includes Professional Liability Insurance for this term of your membership.',
    question: `If you would prefer to exclude
      Professional Liability Insurance from your membership, please indicate this here`,
    optOutOptions: [{ text: 'Continue with Insurance', value: '1' }, { text: 'Exclude Insurance from membership', value: '2' }],
    disclaimer: `Please note that the regulator (GPhC) requires you to have appropriate professional insurance in order to stay on the register.
      If you exclude RCPharm Professional Liability Insurance from your membership, then you must ensure that you have appropriate cover elsewhere.`,
    insuranceMessage: `In applying for RCPharm membership you are also applying for insurance,
      all information material to the proposed insurance benefit must be disclosed fully
      and truthfully and to the best of your knowledge and belief.
      Information is material if it would influence insurers' decision to insure you, what cover is offered to you or what premium is charged.
      If you are in any doubt whether information is material you should disclose it (please click 
      <a href="/insurance/disclosure" target="_blank">here</a> for further details on fair presentation and disclosure).`,
    nextButton: 'Next',
    nonWorkingQuestion: 'Insurance level coverage',
    nonWorkingQuestionDetails: `To give you the appropriate level of insurance, we need to know
      whether you consider yourself employed or self-employed (this should correspond to the last status you had when you were working).
      If you are unsure what that means, please visit <a href="https://portal.aon.co.uk/rcpharm/en/home" target="_blank">
      here</a> for the level of coverage.`,
    nonWorkingEmploymentOptions: [{ text: 'Employed', value: '1' }, { text: 'Self-employed', value: '2' }],
    additionalRoleOptions: [],
    helperForAdditionalRole: `If you are not a Qualified Person or an Aesthetic Pharmacist, please select Not Applicable.<br/>
    For full descriptions of these roles, please click <a href="https://www.rcpharm.org/insurance" target="_blank"> here</a>.
     You may select more than one if they are applicable to your current employment.`,
    additionalRoleQuestion: 'I am an:',
    qpDisclaimer: `*NB – The term "Qualified Person" is a specific role within pharmaceutical industry and does not
      refer to qualification status with the GPhC`,
    qp: 'Qualified Person',
  },
  regulatory: {
    optedOut: true,
    retiredOrOverseas: false,
    process: 'regulatory',
    question: `Have you ever been subject to any regulatory proceedings (this includes open or closed investigations or sanctions,
      regardless of outcome)?`,
    information: `You have answered 'Yes' to one or more of the underwriting questions. The Underwriter may therefore require additional
      information and your cover is subject to the Underwriters approval. <strong>Please note.
      You should not rely on this cover until such approval has been given.</strong>
      If you are declined insurance for any reason, RCPharm will adjust your membership fee accordingly.`,
    claimsQuestion: 'Have you had any claims (this includes open or closed matters, regardless of outcome) in the last 5 years?',
    options: [{ text: 'No I have not', value: '1' }, { text: 'Yes I have', value: '2' }],
    furtherInformation: `Insurance cover is subject to the policy terms and conditions (a copy of the terms and conditions is available on the
      <a href="https://portal.aon.co.uk/rcpharm/en/home" target="_blank"> Professional Liability Insurance portal).</a>`,
    tncsReminder: `Please ensure that you have read and understood the
      <a href="https://www.rcpharm.org/membership-terms-and-conditions" target="_blank">
      Membership Terms and Conditions</a> before proceeding.`,
    nextButton: 'Next',
    backButton: 'Go back',
    detailsFurtherInformation: 'Please provide further details:',
    placeholder: 'Tell us more',
  },
};
/**
 * This function decorates the qp disclaimer ( disclaimer prop) for Qualified Person option
 * @param {Array<{text:String, value: Number}>} roles
 * @returns {Array<{text: String, value: Number, disclaimer: String}>}
 */
const additionalRoleOptions = (roles) => {
  const additionalRoles = roles.map((r) => {
    const role = { disclaimer: r.text === insurance.optOut.qp ? insurance.optOut.qpDisclaimer : null, ...r };
    return role;
  });
  return additionalRoles;
};

export default {
  insuranceData() {
    const i = { ...insurance };
    i.overseas = store.getters.getIsOverseas;
    i.retired = store.getters.isMemberTypeApplicant && store.getters.isRetiredMember;
    i.member = store.getters.isMemberTypeApplicant;
    i.gbFoundationTrainee = store.getters.isGbFoundationTrainee;
    i.overseasFoundationTrainee = store.getters.isOverseasFoundationTrainee;
    i.ftQualifiedIn2025 = store.getters.ftQualifiedIn2025;
    i.overseasFtOrGbFtWhoQualifiedIn2025 = i.overseasFoundationTrainee || i.ftQualifiedIn2025;
    i.regulatory.retiredOrOverseas = i.retired || i.overseas;
    i.optOut.additionalRoleOptions = additionalRoleOptions(store.getters.additionalRoles);

    if (i.member) {
      i.initialComponent = i.regulatory.retiredOrOverseas ? RegulatoryQuestions : OptOutQuestion;
    } else if (i.gbFoundationTrainee) {
      if (i.ftQualifiedIn2025) {
        i.initialComponent = undefined;
        return i;
      }
      i.initialComponent = OptOutQuestion;
    }
    return i;
  },
  getNextComponent(data, componentInsurance) {
    switch (data.process) {
      case componentInsurance.optOut.process:
        componentInsurance.regulatory.optedOut = data.optedOut;
        if (!data.optedOut || componentInsurance.member) {
          return RegulatoryQuestions;
        }
        return undefined;
      default:
        return undefined;
    }
  },
};
